export const BANNER_PAGES = [
  { code: 'HOME', label: 'Home', width: 332, height: 118 },
  { code: 'WALLET', label: 'Wallet', width: 326, height: 136 },
  { code: 'FANTASY', label: 'Fantasy', width: 296, height: 70 },
  { code: 'SHOPPING', label: 'Shopping', width: 326, height: 136 },
  { code: 'OPINION_TRADING', label: 'Opinion Trading', width: 296, height: 70 },
  { code: 'GAME_PAGE', label: 'Game Page', width: 332, height: 118 },
] as const;

export type BannerPage = (typeof BANNER_PAGES)[number]['code'];

export const BANNER_PAGE_OPTIONS = BANNER_PAGES.map(({ code, label }) => ({
  label,
  value: code,
}));

export const BANNER_PAGE_ZOD_ENUM = BANNER_PAGES.map(page => page.code) as [
  BannerPage,
  ...BannerPage[],
];

export const BANNER_FILTER_PAGE_TYPES = [
  'ALL',
  ...BANNER_PAGES.map(page => page.code),
] as ['ALL', ...BannerPage[]];

export const BANNER_ASPECT_RATIO_MAP: Record<BannerPage, number> =
  Object.fromEntries(
    BANNER_PAGES.map(page => [page.code, page.width / page.height])
  ) as Record<BannerPage, number>;

export const BANNER_RECOMMENDED_SIZE_MAP: Record<BannerPage, string> =
  Object.fromEntries(
    BANNER_PAGES.map(page => [page.code, `${page.width} × ${page.height}`])
  ) as Record<BannerPage, string>;

export const IMAGE_RATIO_TOLERANCE = 0.01;

export const isBannerTypeCompatibleWithRatio = (
  bannerType: BannerPage,
  ratio: number
) =>
  Math.abs(BANNER_ASPECT_RATIO_MAP[bannerType] - ratio) <=
  IMAGE_RATIO_TOLERANCE;

export const BANNER_STATUSES = ['ACTIVE', 'HIDDEN', 'EXPIRED'] as const;

export type BannerStatus = (typeof BANNER_STATUSES)[number];

export const BANNER_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Hidden', value: 'HIDDEN' },
  { label: 'Expired', value: 'EXPIRED' },
] as const;

export const BANNER_FILTER_STATUS_TYPES = ['ALL', ...BANNER_STATUSES] as [
  'ALL',
  ...BannerStatus[],
];

export const DEFAULT_BANNER_PAGE: BannerPage = BANNER_PAGES[0].code;
